// extracted by mini-css-extract-plugin
export default {"dt":"Row_dt__Yslyc","dd":"Row_dd__MgEjO","login-data-table_row-body":"Row_login-data-table_row-body__xxL+A"};